import { IFullTemplate, Question } from '../../config/interfaces';

/**
 * Store sub context for template data
 */
const TemplateContext = {
  chosenSurvey: {} as any,
  loading: true,
  questionsOfTemplate: [] as Question[],
  templateById: {} as IFullTemplate,
  allQuestions: [] as Question[],
  isQuestionListLoading: false,
  loadingQuestion: false,
  selectedQuestionId: '',
  editQuestion: false
};

export default TemplateContext;
